<!--- Formulario frmManageShoppingLocationIndex ---->
<!---
Descripción del componente y comportamiento:
CASO  DE USO:
  * APP07_Gestionar Ubicación Ventas
  * https://grupohispatec.sharepoint.com/:w:/s/Produccin/EclS4s5Oaq1PuUP1WHC5p8cBGanR8-vjjhw25VASNY9mEQ
---------------------------
- Formulario para Gestionar la ubicación de las compras.

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page
    class="main-frmManageSalesLocation"
  >
    <template #fixed>
      <TheNavbar
        nav-title="Gestionar ubicación Ventas"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
      >
        <template #right>
          <div
            v-if="mainData != null && !showPreload && mainData != null && mainData.DocumentoOrigen != null && mainData.TipoDocumentoOrigen === 1"
            class="display-flex"
          >
            <f7-link
              @click="EventClickGenerateSalesDeliveryNote"
            >
              <img
                width="38px"
                class="img"
                :src="iconPlay"
              >
            </f7-link>
          </div>
          <div
            class="display-flex"
          >
            <f7-link
              @click="EventOpenReadBarCode"
            >
              <img
                class="img"
                :src="iconQr"
              >
            </f7-link>
          </div>
        </template>
      </TheNavbar>
    </template>
    <div class="padding-half header">
      <template v-if="!showPreload && mainData != null">
        <div class="header__texto margin-top-half">
          <template v-if="mainData.DocumentoOrigen != null">
            <!-- Pedido de venta -->
            <template v-if="mainData.TipoDocumentoOrigen === 1">
              <span class="header__title">Pedido de Venta:</span>
              <span class="header__texto">
                {{ `${mainData.DocumentoOrigen.Serie}/${mainData.DocumentoOrigen.Numero}` }}
              </span>
              <span v-if="mainData.DocumentoOrigen.Cliente != null">
                {{ mainData.DocumentoOrigen.Cliente.Sujeto.NombreCompleto }}
              </span>
            </template>

            <!-- Parte de producción -->
            <template v-if="mainData.TipoDocumentoOrigen === 2">
              <span class="header__title">Parte de Producción:</span>
              <span class="header__texto">
                {{ `${mainData.DocumentoOrigen.Serie}/${mainData.DocumentoOrigen.Numero}` }}
              </span>
            </template>
          </template>

          <!-- Sin documento origen -->
          <template v-else-if="mainData.TipoDocumentoOrigen === 0">
            <span class="header__title">Lista de Ubicación:</span>
            <span class="header__texto">
              {{ `${mainData.Serie}/${mainData.Numero}` }}
            </span>
          </template>
        </div>
      </template>
    </div>
    <UCEmptyList
      v-if="mainData === null && !showPreload"
      class="emptyList"
      title="Sin documento seleccionado"
      subtitle="Pulse el botón para añadir un nuevo documento"
      :icon="iconQr"
      @click-icon="EventOpenReadBarCode"
    />

    <UCPreload :show="showPreload" />

    <f7-block class="no-padding no-margin-top">
      <f7-toolbar
        v-if="mainData != null && !showPreload"
        tabbar
        class="content-tab bg-lightsnow"
      >
        <a
          class="tab-link"
          :class="{ 'tab-link-active': (tabSelected === enumTabs.ITEMS) }"
          @click="EventChangeDisplayOptionTabs(enumTabs.ITEMS)"
        >
          <span class="tabbar-label">{{ $t('common.articles') }}</span>
        </a>
        <a
          class="tab-link"
          :class="{ 'tab-link-active': tabSelected === enumTabs.STOCKS }"
          @click="EventChangeDisplayOptionTabs(enumTabs.STOCKS)"
        >
          <span class="tabbar-label">{{ $t('common.stocks') }}</span>
        </a>
      </f7-toolbar>
    </f7-block>
    <!-- Campo de busqueda de Artículos -->
    <div class="input-busqueda">
      <f7-list
        v-if="mainData != null && !showPreload"
        no-hairlines-md
      >
        <f7-list-input
          type="text"
          placeholder="Buscar por artículo"
          clear-button
          :value="localFilterText"
          @input="localFilterText = $event.target.value"
        />
        <div
          v-if="localFilterText === ''"
          class="container__img"
        >
          <img src="@/static/icons/ic_shape.svg">
        </div>
      </f7-list>
    </div>

    <f7-tabs
      v-if="mainData != null && !showPreload"
      animated
    >
      <!--  ------------------------------- -->
      <!-- TAB  1  ITEMS ( ARTICULOS DEL PICKING LIST ) -->
      <!--  ------------------------------- -->
      <f7-tab
        id="tab-1"
        tab-active
      >
        <div class="tabla-articulos">
          <!-- <pre> {{ mainData }} </pre> -->
          <!-- <pre> {{ mainDataFiltered }} </pre> -->
          <div
            v-if="!showPreload && mainData != null && mainData.hasOwnProperty('Lineas') && mainData.Lineas != null && mainData.Lineas.length > 0"
            class="content-accordion"
          >
            <f7-list>
              <f7-list-item
                v-for="(item, i) in mainDataFiltered != null ? mainDataFiltered.Lineas : mainData.Lineas"
                :key="i"
                media-list
                :subtitle="`${item.Articulo.Codigo != null ? item.Articulo.Codigo : ''}`"
                link="#"
                :class="[
                  item.hasOwnProperty('CantidadPosicionadaAlmacenDestino')
                    && item.hasOwnProperty('Cantidad')
                    && item.CantidadPosicionadaAlmacenDestino === item.Cantidad
                    ? 'finished-items'
                    : 'pending-items',
                ]"
                @click="EventClickArticle(item)"
              >
                <template #title>
                  <div>
                    <span class="titlea">
                      {{ item.Articulo != null ? item.Articulo.Nombre : '' }}
                    </span>
                    <div class="btn-add-info-output-worker">
                      <img
                        class="content-list-queue-item__icon"
                        width="20"
                        alt="iconInfo"
                        src="@/static/img/ic_gallery.svg"
                        @click="OpenImagenesEntidad(item.Articulo.Id)"
                      >
                    </div>
                  </div>
                </template>

                <div class="content-accordion__quantity-info-btn">
                  <span>
                    {{ `${$t('common.stocks')}:` }}
                    {{
                      item.hasOwnProperty('CantidadDisponibleAlmacenOrigen')
                        ? item.CantidadDisponibleAlmacenOrigen
                        : 0
                    }}
                    Unidades
                  </span>
                </div>
                <!-- <pre> {{ item }} </pre> -->

                <template #after>
                  <div>
                    {{
                      item.hasOwnProperty('CantidadPosicionadaAlmacenDestino')
                        ? item.CantidadPosicionadaAlmacenDestino
                        : 0
                    }}
                    de
                    {{
                      item.hasOwnProperty('Cantidad')
                        ? item.Cantidad
                        : 0
                    }}
                  </div>
                </template>
              </f7-list-item>
            </f7-list>
          </div>
        </div>
      </f7-tab>
      <!--  ------------------------------- -->
      <!-- TAB  2  STOCKS (EXISTENCIAS DEL PICKING LIST) -->
      <!--  ------------------------------- -->
      <f7-tab id="tab-2">
        <div class="tabla-acordeon">
          <div
            v-if="!showPreload && pickingList != null && pickingList.hasOwnProperty('Lineas') && pickingList.Lineas != null && pickingList.Lineas.length > 0"
            class="content-accordion"
          >
            <UCAcordeon
              :items="pickingListFiltered != null ? pickingListFiltered.Lineas : pickingList.Lineas"
              name-element-item="items"
              badge-text-color="var(--his-oliva)"
              :opened-index="itemAcordeonOpen"
              :closed="true"
              :after-title="!disallowLocationAdvancement"
              :show-badge="false"
              :show-item-border-bottom="true"
              border-item-bottom-color="#E5EEF7"
              chevron-side="left"
              group-items
              group-key="Ubicacion.Id"
            >
              <template #after="{ item }">
                <img
                  :src="iconDetail"
                  @click="EventSelectedElemenParentAcordeon(item)"
                >
              </template>
              <template #titleOption="{ option }">
                <div class="display-flex align-items-center">
                  <img
                    v-if="option.items.filter(e => e.UbicadoEnUbicacionPorDefecto).length > 0"
                    class="padding-right-half"
                    width="20"
                    alt="iconWarning"
                    src="@/static/icons/ic_warning.svg"
                  >
                  {{ option.group.Nombre }}
                </div>
              </template>

              <template #subOption="{ item }">
                <f7-list-item
                  media-list
                  link="#"
                  :subtitle="`
                  ${
                    item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo != null
                      ? item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Codigo
                      : ''
                  }`"
                  :class="[
                    item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('CantidadPosicionadaAlmacenDestino')
                      && item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('Cantidad')
                      && item.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino === item.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad
                      ? 'finished-items'
                      : 'pending-items',
                  ]"
                >
                  <template #title>
                    <div>
                      <span class="titlea">
                        {{ item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo != null
                          ? item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Nombre
                          : '' }}
                      </span>
                      <div class="btn-add-info-output-worker">
                        <img
                          v-if="item.UbicadoEnUbicacionPorDefecto"
                          class="margin-left-half"
                          width="20"
                          alt="iconWarning"
                          src="@/static/icons/ic_warning.svg"
                        >
                        <img
                          class="content-list-queue-item__icon"
                          width="20"
                          alt="iconInfo"
                          src="@/static/img/ic_gallery.svg"
                          @click="OpenImagenesEntidad(item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id)"
                        >
                      </div>
                    </div>
                  </template>

                  <div class="content-accordion__quantity-info-btn">
                    <span>
                      {{ `${$t('common.stocks')}:` }}
                      {{
                        item.hasOwnProperty('CantidadDisponibleUbicacion')
                          ? item.CantidadDisponibleUbicacion
                          : 0
                      }}
                      Unidades
                    </span>
                  </div>
                  <!-- pre> {{ item.AcumuladoExistencias }} </pre> -->

                  <template #after>
                    <div>
                      {{
                        item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('CantidadPosicionadaAlmacenDestino')
                          ? item.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino
                          : 0
                      }}
                      de
                      {{
                        item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('Cantidad')
                          ? item.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad
                          : 0
                      }}
                    </div>
                  </template>
                </f7-list-item>
              </template>
            </UCAcordeon>
          <!-- <pre> {{ pickingList }}</pre> -->
          </div>
          <div class="content-button">
            <f7-button
              v-if="mainData != null"
              class="btn-confirmar"
              fill
              @click="EventOpenReadBarCodeForLocation()"
            >
              Escanear ubicación
            </f7-button>
          </div>
        </div>
      </f7-tab>
    </f7-tabs>

    <!-- Componente de Escaner de códigos -->
    <UCCodeScanner
      ref="UCCodeScanner"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="true"
      @code-reading="CodeScannerReaded"
      @codigo-barras="CodeScannerReaded"
    />

    <f7-popup
      class="frmManageSalesLocation-popup-images"
      :opened="popupImagenes"
      @popup:closed="popupImagenes = false"
    >
      <f7-navbar
        :title="$t('common.files')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupImagenes = false">
            <img
              :src="icClose"
              style="padding-right: 10px;"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCImagenesEntidad
        v-if="idEntidad != null"
        :is-active="popupImagenes"
        :entity-id="idEntidad"
        entity-type="Articulo"
        @open-pdf="popupImagenes = false"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useCommercialisationStore } from '@/js/stores/commercialisation';
import { useParamRef } from '@erpagroapp/params';

import icDetail from '@/static/img/ic_detail.svg';
import icQr from '@/static/icons/ic_qr.svg';
import icPlay from '@/static/icons/ic_play_btn_yellow.svg';
import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { TipoDocumento } from '@/js/common/enum';
import CommonController from '@/js/controllers/CommonController';
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import PCImagenesEntidad from '@/components/production/traceability/PCImagenesEntidad.vue';
import icClose from '@/static/icons/ic_close.svg';
import { ConfirmDialogGH, HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

/** @import { ListaDeUbicacionesParaRecoleccion } from '@erpagroapp/types' */

export default {
  name: 'FrmManageSalesLocationIndex',

  components: {
    TheNavbar,
    UCAcordeon,
    UCPreload,
    UCCodeScanner,
    UCEmptyList,
    PCImagenesEntidad,
  },

  props: {
    // Código de barras de pedido de venta o lista de ubicaciones para recolección, se utiliza para ser llamado al inicializar el formulario.
    barCode: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showPreload: false, // Mostrar preload
      itemAcordeonOpen: 0, // Item del acordeon abierto.
      scanMode: 0, // Modo de escaneo
      enumScanMode: {
        NONE: 0,
        LOCATION: 1, // Ubicación
        OTHERS: 2, // (Albaran de compra, Pedido de venta, Lista de Ubicaciones, Lista de ubicaciones para recolección)
      },
      enumTabs: { // Pestañas disponibles en el formulario
        ITEMS: 0, // Artículos
        STOCKS: 1, // Existencias
      },
      tabSelected: 0, // Pestaña seleccionada
      mainData: null, // Contiene el ListaDeUbicacionesParaRecoleccion desde los que se genera la lista de artículos para la selección segun las existencias (picking list).
      mainDataFiltered: null, // Contiene el mainData filtrado por el texto de busqueda.
      pickingListFiltered: null, // Contiene el pickingList filtrado por el texto de busqueda.
      localFilterText: '', // Texto de filtro para la lista de artículos.
      idDocumentRead: 0, // Id del documento leido (pedido de venta o lista de ubicaciones para recolección) controlado con typeOfDocumentRead
      typeOfDocumentRead: null, // Tipo de documento leido (pedido de venta o lista de ubicaciones para recolección).
      itemSelecte: null,
      popupImagenes: false,
      idEntidad: null, // id de la entidad a pasar a PCImagenes entidad
      icClose,
      optionsSelected: false, // Para solo mostrar el Popup o las imagenes
      disallowLocationAdvancement: useParamRef('NoPermitirAvanzarEnGestionUbicacionesAPP'),
    };
  },

  computed: {
    ...mapWritableState(useCommercialisationStore, [
      'pickingList', // Documento con la lista de ubicaciones del documento seleccionado.
      'filterText', // Texto de filtro para la lista de artículos.
      'ResetFrmLocationSales',
      'locationSelected', // Ubicación seleccionada
      'locationsArticlesSelected', // Artículos de la ubicación seleccionada
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
    iconDetail() {
      return icDetail;
    },
    iconQr() {
      return icQr;
    },
    iconPlay() {
      return icPlay;
    },
  },

  watch: {
    barCode(val) {
      if (val !== '') {
        // this.GetSalesOrders(e.substring(6, 12)); // 10010IIIIIIC
        this.CodeScannerReaded(val);
      }
    },
    ResetFrmLocationSales(val) {
      if (val) {
        this.RefreshPage();
      }
    },
    localFilterText(val) {
      this.FilterData(val);
    },
    // Desde el formulario de Detalles se puede borrar el filtro del Store lo que debe actualizar nuestro filtro local.
    filterText(newVal) {
      this.localFilterText = newVal;
    },
  },

  created() {
    this.ResetFrmLocationSales = false;
    this.StartComponent();
  },

  beforeUnmount() {
    this.EndComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.scanMode = this.enumScanMode.NONE;
      this.typeOfDocumentRead = TipoDocumento.ND;
      this.pickingList = null;
      this.mainData = null;
      if (this.barCode !== '') {
        this.scanMode = this.enumScanMode.OTHERS;
        this.CodeScannerReaded(this.barCode);
      }
    },
    EndComponent() {
      Log(this, this.EndComponent.name);
      this.pickingList = null;
      this.locationSelected = null;
      this.locationsArticlesSelected = null;
      this.filterText = '';
    },
    async Init() {
      Log(this, this.Init.name);
      this.localFilterText = '';
      await sleep(100);
      this.pickingList = null;
      this.pickingList = null;
      this.locationSelected = null;
      this.locationsArticlesSelected = null;
      this.filterText = '';
      f7.tab.show('#tab-1', true);
      this.typeOfDocumentRead = TipoDocumento.ND;
      this.tabSelected = this.enumTabs.ITEMS;
      this.itemAcordeonOpen = 0;
      this.mainData = null;
      this.mainDataFiltered = null;
      this.pickingListFiltered = null;
      this.idDocumentRead = 0;
      this.itemSelecte = null;
    },
    /// Se llama para recargar la pagina desde el detalle.
    async RefreshPage() {
      Log(this, this.RefreshPage.name);
      PreloaderGH(true, true, 'Cargando', this.$t('common.updatingInformation'));
      await this.GetMainData(this.idDocumentRead);
      const las = this.pickingList.Lineas.filter((e) => e.Ubicacion.Id === this.itemSelecte[0].Ubicacion.Id); // Las ubicaciones siempre son las mismas en los elementos seleccionados.
      this.locationsArticlesSelected = las;
      await this.FilterData('reset');
      f7.tab.show('#tab-2', true);
      this.ResetFrmLocationSales = false;
      PreloaderGH(false);
    },
    OpenImagenesEntidad(item) {
      this.optionsSelected = true;
      this.idEntidad = item;
      this.popupImagenes = true;
    },
    async FilterData(val) {
      if (this.mainData == null || val === '') {
        this.mainDataFiltered = { ...this.mainData };
        this.pickingListFiltered = { ...this.pickingList };
        return;
      }
      this.mainDataFiltered = { ...this.mainData, Lineas: this.mainData.Lineas.filter((item) => item.Articulo.Nombre.toLowerCase().includes(this.localFilterText.toLowerCase())) };
      this.pickingListFiltered = { ...this.pickingList, Lineas: this.pickingList.Lineas.filter((item) => item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Nombre.toLowerCase().includes(this.localFilterText.toLowerCase())) };
    },

    async GetMainData(IdDocument) {
      Log(this, this.GetMainData.name);

      if (!this.ResetFrmLocationSales) {
        this.pickingList = null;
      }

      this.showPreload = true;
      this.idDocumentRead = IdDocument;

      const typeToValue = {
        [TipoDocumento.PEDIDO_VENTA]: 1,
        [TipoDocumento.PARTE_PRODUCCION]: 2,
      };
      const typeValue = typeToValue[this.typeOfDocumentRead] || 0;

      this.mainData = await this.Conections_GetMainData(
        IdDocument,
        typeValue,
      );

      if (!this.mainData || this.mainData.length === 0) {
        HiNotification.Alert('Lista de ubicaciones para recolección no localizada', 'Ubicación para ventas');
      } else {
        this.pickingList = this.BuildPickingList(this.mainData);
      }

      this.showPreload = false;
    },

    /**
     * Genera la estructura valida para mostrar los datos en pantalla (Pestaña de Existencias)
     * Para cada línea de la mercancía que se tiene que recolectar, se agrupan las existencias disponibles por artículo y ubicación y se suman las cantidades.
     * @param {ListaDeUbicacionesParaRecoleccion} data entidades de ERP.
     * @returns {ListaDeUbicacionesParaRecoleccion} estructura final.
     */
    BuildPickingList(data) {
      Log(this, this.BuildPickingList.name);
      const tempPickingList = {
        Id: data.Id,
        Serie: data.Serie,
        Numero: data.Numero,
        Fecha: data.Fecha,
        TipoDocumentoOrigen: data.TipoDocumentoOrigen,
        DocumentoOrigen: data.DocumentoOrigen,
        Lineas: [],
        UbicacionParaPreparacion: data.UbicacionParaPreparacion,
      };
      data.Lineas.forEach((ln) => {
        ln.AcumuladoExistencias.forEach((ae) => {
          const line = tempPickingList.Lineas.find((e) => e.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id === ln.Articulo.Id && e.Ubicacion.Id === ae.Ubicacion.Id);
          if (line) {
            line.CantidadDisponibleUbicacion += ae.Cantidad;
            line.AcumuladoExistencias.push(ae);
          } else {
            tempPickingList.Lineas.push({
              MercanciaListaDeUbicacionesParaRecoleccion: { ...ln, AcumuladoExistencias: [] }, // Copia con el AE vacio
              Ubicacion: ae.Ubicacion,
              CantidadDisponibleUbicacion: ae.Cantidad,
              AcumuladoExistencias: [ae],
              // si la ubicación pertenece a un almacén no móvil y la ubicación en la que se encuentra no es su ubicación por defecto para ese almacén, poner una alerta al lado del nombre la ubicacion
              UbicadoEnUbicacionPorDefecto: !ae.Almacen.AlmacenMovil && ae.UbicacionDefectoArticulo != null && ae.Ubicacion.Id !== ae.UbicacionDefectoArticulo.Id, // TODO
            });
          }
        });
      });
      return tempPickingList;
    },
    async BackToMain() {
      if (this.mainData != null) {
        const resultConfirm = await ConfirmDialogGH('Tienes una lista de selección de mercancía en curso. ¿Quieres salir del proceso?', 'Salir');
        if (!resultConfirm) {
          return;
        }
      }
      f7.views.main.router.clearPreviousHistory();
      f7.views.main.router.navigate('/', { force: true });
    },

    NavigateToLocationDetails(location, item) {
      Log(this, this.NavigateToLocationDetails.name);
      this.locationSelected = location;
      this.itemSelecte = item;
      this.locationsArticlesSelected = item;
      this.filterText = this.localFilterText;
      f7.views.main.router.navigate('/warehouse/manageSalesLocation/frmManageSalesLocationDetails');
    },
    ValidateSalesOrder(salesOrder) {
      Log(this, this.ValidateSalesOrder.name);
      // Los pedidos de venta que esten en estado Servido (Albaranados) no se pueden utilizar en este proceso.
      if (salesOrder.EstadoPedido === 3) {
        HiNotification.Alert(`El pedido de venta ${salesOrder.Serie}/${salesOrder.Numero} se encuentra en estado servido, no es posible utilizarlo en este proceso.`, 'Pedido de venta servido'); // e4 del CU
        return false;
      }
      // Los pedidos de venta que esten en estado Rechazado no se pueden utilizar en este proceso.
      if (salesOrder.EstadoPedido === 2) {
        HiNotification.Alert(`El pedido de venta ${salesOrder.Serie}/${salesOrder.Numero} se encuentra en estado rechazado, no es posible utilizarlo en este proceso.`, 'Pedido de venta rechazado'); // e4 del CU
        return false;
      }
      // Los pedidos de venta que esten en estado Propuesta no se pueden utilizar en este proceso.
      if (salesOrder.EstadoPedido === 0) {
        HiNotification.Alert(`El pedido de venta ${salesOrder.Serie}/${salesOrder.Numero} se encuentra en estado propuesta, no es posible utilizarlo en este proceso.`, 'Pedido de venta en propuesta'); // e4 del CU
        return false;
      }
      return true;
    },
    /** Genera el albaran de venta y imprime el impreso de negocio  0128 */
    async GenerateSalesDeliveryNote() {
      Log(this, this.GenerateSalesDeliveryNote.name);
      PreloaderGH(true, true, 'Cargando', 'Generando albarán de venta...');
      const result = await this.Conections_GenerateSalesDeliveryNoteFromPickingList(this.mainData);
      PreloaderGH(false);
      if (result.Valor) {
        HiNotification.Toast('Albarán de venta generado correctamente');
        this.StartComponent();
      } else {
        HiNotification.Alert('No se ha podido generar el albarán de venta', this.$t('common.warning'));
      }
    },

    EventOpenReadBarCodeForLocation() {
      Log(this, this.EventOpenReadBarCodeForLocation.name);
      this.scanMode = this.enumScanMode.LOCATION;
      this.$refs.UCCodeScanner.Open();
    },
    EventClickArticle(e) {
      Log(this, this.EventClickArticle.name);
      if (!this.optionsSelected) {
        this.localFilterText = e.Articulo.Nombre;
        this.EventChangeDisplayOptionTabs(this.enumTabs.STOCKS);
      }
      this.optionsSelected = false;
    },
    async EventOpenReadBarCode() {
      Log(this, this.EventOpenReadBarCode.name);
      this.scanMode = this.enumScanMode.OTHERS;
      if (this.pickingList != null) {
        const resultConfirm = await ConfirmDialogGH('Tienes una lista de selección de mercancía en curso. ¿Quieres salir para leer otra lista?', 'Leer nueva lista de selección de mercancía');
        if (resultConfirm) {
          // this.pickingList = null;
          // this.pickingList = null;
          this.Init();
        } else {
          return;
        }
      }
      this.$refs.UCCodeScanner.Open();
    },
    async EventClickGenerateSalesDeliveryNote() {
      Log(this, this.EventClickGenerateSalesDeliveryNote.name);
      const resultConfirm = await ConfirmDialogGH('Esta acción generará el albarán de venta con las cantidades movidad. ¿Quieres continuar con el proceso?', 'Generar albarán de venta');
      if (resultConfirm) {
        this.GenerateSalesDeliveryNote();
      }
    },
    async EventSelectedElemenParentAcordeon(e) {
      Log(this, this.EventSelectedElemenParentAcordeon.name);
      this.NavigateToLocationDetails(e.group, e.items);
    },

    async EventLocationSelected(e) {
      Log(this, this.EventLocationSelected.name);

      if (!e) {
        return;
      }

      // El popup de busqueda de ubicaciones tarda en cerrarse, por lo que se espera un poco para que no se cierre antes de que se cierre el popup de lectura de codigo.
      await sleep(200);
      this.$refs.UCCodeScanner.ClosePopup();

      const lines = this.pickingList.Lineas.filter((element) => element.Ubicacion.Id === e.Id);

      if (lines?.length > 0) {
        this.NavigateToLocationDetails(e, lines);
      } else {
        HiNotification.Alert(
          `La ubicación ${e.Codigo}-${e.Nombre} no dispone de existencias para los artículos de este pedido de venta.`,
          'Ubicación sin existencias',
        );
      }
    },

    EventPurchaseOrderSelected(e) {
      Log(this, this.EventPurchaseOrderSelected.name);
      if (e !== null) {
        this.$refs.UCCodeScanner.ClosePopup();
      }
    },

    async CodeScannerReaded(e) {
      Log(this, this.CodeScannerReaded.name);

      if (this.scanMode === this.enumScanMode.LOCATION) {
        const result = await this.GetLocationByFilter(`barcode:${e}`);

        if (result !== null && (result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
          this.EventLocationSelected(result.data[0]);
        } else {
          HiNotification.Toast('El código de barras de la ubicación no es correcto');
        }
      } else if (this.scanMode === this.enumScanMode.OTHERS) {
        this.typeOfDocumentRead = CommonController.DeterminateBarCodeType(e);

        if (this.typeOfDocumentRead === TipoDocumento.PEDIDO_VENTA) { // 10010IIIIIIC
          this.GetSalesOrders(e.substring(6, 12));
        } else if (this.typeOfDocumentRead === TipoDocumento.LISTA_UBICACION_PREPARACION
          || this.typeOfDocumentRead === TipoDocumento.PARTE_PRODUCCION) { // 10012IIIIIIC o 100040IIIIIIC
          this.GetMainData(e.substring(6, 12));
        } else if (this.typeOfDocumentRead === TipoDocumento.ALBARAN_COMPRA
          || this.typeOfDocumentRead === TipoDocumento.LISTA_UBICACION) { // 10009IIIIIIC  o  10011IIIIIIC
          f7.views.main.router.navigate('/warehouse/manageShoppingLocation/frmManageShoppingLocation', {
            reloadCurrent: true, // Reemplaza la actual página con la nueva.
            props: {
              barCode: e,
            },
          });
        } else {
          HiNotification.Toast('El código de barras no es correcto');
        }
      }

      this.scanMode = this.enumScanMode.NONE;
    },

    EventChangeDisplayOptionTabs(tab) {
      Log(this, this.EventChangeDisplayOptionTabs.name);

      // Comprobamos si estamos en la misma pestaña
      if (this.tabSelected === tab) {
        return;
      }

      if (this.tabSelected === this.enumTabs.STOCKS) {
        this.localFilterText = '';
        this.filterText = '';

        this.tabSelected = this.enumTabs.ITEMS;
        f7.tab.show('#tab-1', true);
      } else {
        this.tabSelected = this.enumTabs.STOCKS;
        f7.tab.show('#tab-2', true);
      }
    },

    GetLocationByFilter(filter) {
      Log(this, this.GetLocationByFilter.name);
      return callExecuteSPERP(
        'APPERPAGRO_Ubicaciones',
        [{ NombreParametro: 'filtro', Valor: filter }],
        'Almacen.UbicacionJSON',
      );
    },
    async GetSalesOrders(id) {
      Log(this, this.GetSalesOrders.name);
      this.showPreload = true;
      try {
        let result = null;
        if (id !== null && id !== undefined) {
          result = await callExecuteSPERP(
            'APPERPAGRO_PedidosVenta',
            [{ NombreParametro: 'filtro', Valor: `Ids:${id}` }],
            'Ventas.PedidoVentaJSON',
          );
          this.showPreload = false;
          if ((result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
            if (this.ValidateSalesOrder(result.data[0])) {
              await this.GetMainData(result.data[0].Id);
              return result.data[0];
            }
            return null;
          }

          HiNotification.Toast('El pedido de venta no existe');
          return null;
        }
      } catch (error) {
        LogError(this, this.GetSalesOrders.name, error);
        this.showPreload = false;
        return null;
      }
      return null;
    },
    /* Metodo que obtiene la lista de ubicaciones paraRecolección desde un Id de pedido de venta */
    async Conections_GetMainData(id, typeOfDocument) {
      Log(this, this.Conections_GetMainData.name);
      try {
        const result = await callExecuteSPERP(
          'APPERPAGRO_ListaDeUbicacionesParaRecoleccion',
          [
            { NombreParametro: 'id', Valor: id },
            { NombreParametro: 'tipoDocumento', Valor: typeOfDocument },
          ],
          'Almacen.ListaDeUbicacionesParaRecoleccionJSON',
        );
        if ((result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
          return result.data[0];
        }
      } catch (error) {
        LogError(this, this.Conections_GetMainData.name, error);
      }
      return null;
    },
    /* Metodo que generá el abaran de venta desde la lista de ubicaciones para recolección */
    async Conections_GenerateSalesDeliveryNoteFromPickingList(data) {
      Log(this, this.Conections_GenerateSalesDeliveryNoteFromPickingList.name);
      try {
        const result = await APIErp.callGenerateSalesDeliveryNoteFromPickingList(data);
        if (result.statusText === 'OK' || result.status === 200) {
          return result.data;
        }
      } catch (error) {
        LogError(this, this.Conections_GenerateSalesDeliveryNoteFromPickingList.name, error);
        return { Valor: false, Mensaje: 'Error al generar el albarán de venta' };
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.main-frmManageSalesLocation {
  .page-content {
    overflow-y: hidden;
  }

  .content-tab {
    margin-bottom: -15px;

    .tab-link-highlight {
      display: none;
    }

    .tab-link {
      border-right: 1px solid var(--his-silver);

      .tabbar-label {
        color: var(--his-darkness);
        text-transform: none;
        font-size: 18px;
        opacity: 0.5;
      }
    }

    .tab-link-active {
      border-bottom: 4px solid var(--his-silver);

      .tabbar-label {
        opacity: 1;
        font-weight: 400;
      }
    }
  }

  .input-busqueda {
    background: #fff;

    .list {
      display: flex;
      width: 100%;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      ul {
        min-width: 90vw;
      }

      .item-content {
        .item-inner {
          display: flex;
          flex-direction: row;
          align-items: center;

          .item-input-wrap {
            .input-clear-button {
              /* margin-right: -25px; */
            }
          }
        }
      }
    }

    .container__img {
      display: flex;
      width: 10vw;
      height: 5vh;
      flex-direction: row;
      align-content: center;
      align-items: center;

      img {
        height: 16px;
        width: 16px;
      }
    }
  }

  .tab {
    height: 60vh;
    overflow-y: auto;
  }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  .header {
    background: var(--his-oliva);

    span {
      color: #fff;
    }

    &__title {
      margin-left: 8px;
      font-size: 12px;
      opacity: 0.8;
    }

    &__texto {
      font-size: 14px;
    }
  }

  .tabla-articulos {
    --f7-list-item-title-text-color: var(--his-dark-blue);
    --f7-list-item-title-font-size: 16px;
    --f7-list-item-title-font-weight: 600;
    --f7-list-item-after-font-size: 11px;
    --f7-list-item-after-font-weight: 500;
    --f7-list-item-subtitle-font-size: 11px;
    --f7-list-item-subtitle-line-height: 1.8;
    --f7-list-item-subtitle-text-color: var(--his-oliva);
    --f7-list-item-text-font-size: 11px;
    --f7-list-item-text-text-color: var(--his-ash-gray);
    --f7-list-item-text-line-height: 1;
    --f7-list-chevron-icon-color: var(--his-oliva);

    li {
      &.pending-items .item-after {
        color: #ba5333;
        background-color: var(--his-mandarina-tint);
      }

      &.finished-items .item-after {
        background-color: #e5f6d3;
        color: #66ba33;
      }

      .item-content {
        font-size: 11px;
        color: var(--his-oliva);

        .item-title-row {
          align-items: center;

          .item-after {
            padding: 4px 8px;
            border-radius: 3px;
          }
        }
      }
    }

    .item-footer {
      div {
        display: flex;
        margin-right: 25px;
        margin-top: 5px;
        align-items: flex-end;
        justify-content: space-between;
      }
    }

    .content-accordion {
      &__quantity-info-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn-add-info-output-worker {
          padding-right: 40px;
        }
      }

      .item-title {
        /* display: flex;
            justify-content: flex-end;
            flex-direction: row-reverse; */
        div {
          display: flex;
          justify-content: flex-end;
          flex-direction: row-reverse;

          .titlea {
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            margin-top: 2px;
          }

          .btn-add-info-output-worker {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .tabla-acordeon {
    .content-accordion {
      .storybook-action-sorted-accordion {
        .accordion-list {
          .accordion-item {
            .item-inner {
              font-size: 11px;
              color: var(--his-oliva);

              .item-content {
                background: var(--his-slate-blue);

                .item-title {
                  color: var(--his-light-blue);
                  font-weight: 600;
                  font-size: 15px;
                }
              }
            }
          }

          ul {
            .accordion-item-opened {
              .item-inner {
                .item-content {
                  .item-after {
                    background-color: var(--his-slate-blue) !important;
                  }

                  .item-title {
                    color: var(--his-light-blue);
                  }
                }
              }

              .item-link {
                &::after {
                  border-top: 0;
                }

                .item-content {
                  background-color: #fff;
                  padding-right: 5px;
                }
              }
            }
          }
        }

        .accordion-item-content {
          --f7-list-item-title-text-color: var(--his-dark-blue);
          --f7-list-item-title-font-size: 16px;
          --f7-list-media-item-title-font-weight: 600;
          --f7-list-item-after-font-size: 11px;
          --f7-list-item-after-font-weight: 500;
          --f7-list-item-subtitle-font-size: 11px;
          --f7-list-item-subtitle-line-height: 1.8;
          --f7-list-item-subtitle-text-color: var(--his-oliva);
          --f7-list-item-text-font-size: 11px;
          --f7-list-item-text-text-color: var(--his-ash-gray);
          --f7-list-item-text-line-height: 1;
          --f7-list-chevron-icon-color: var(--his-oliva);

          li {
            &.pending-items .item-after {
              color: #ba5333;
              background-color: var(--his-mandarina-tint);
            }

            &.finished-items .item-after {
              background-color: #e5f6d3;
              color: #66ba33;
            }

            .item-content {
              .item-title-row {
                align-items: center;

                .item-after {
                  padding: 4px 8px;
                  border-radius: 3px;
                }
              }
            }
          }

          .item-title {
            /* display: flex;
              justify-content: flex-end;
              flex-direction: row-reverse; */
            div {
              display: flex;
              justify-content: flex-end;
              flex-direction: row-reverse;

              .titlea {
                -webkit-box-orient: vertical;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                margin-top: 2px;
              }

              .btn-add-info-output-worker {
                margin-right: 10px;
              }
            }
          }
        }
      }

      &__quantity-info-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn-add-info-output-worker {
          padding-right: 40px;
        }
      }
    }

    .content-button {
      position: fixed;
      bottom: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 195px;
      z-index: 1000;

      .button {
        width: 90%;
        --f7-button-pressed-bg-color: var(--his-slate-blue);
        --f7-button-bg-color: var(--his-green);
      }
    }
  }
}

.frmManageSalesLocation-popup-images {
  overflow-y: scroll;
}
</style>
